import "./index.scss";

import classnames from "classnames";

import Icon from "common/core/icon";
import { useCopy } from "util/clipboard";

type Props = {
  value: string;
  className?: string;
};

function CopyButton(props: Props) {
  const { value, className } = props;

  const { copy, recentlyCopied } = useCopy();

  const iconCx = classnames("CopyButton--icon", className, {
    "CopyButton--icon__copied": recentlyCopied,
  });

  return (
    <Icon className={iconCx} name={recentlyCopied ? "tick" : "copy"} onClick={() => copy(value)} />
  );
}

export default CopyButton;
